//Debounce functionality in add gift
function debounce(cb, delay = 800) {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      cb(...args);
    }, delay);
  };
}

const handleAutoGiftByThreshold = async () => {
    const gamificationWrapper = document.querySelector('.gamification-content-wrapper');
    if (!gamificationWrapper || window.getComputedStyle(gamificationWrapper).display === "none") {
      return;
    }
  try {
    const thresholdCents = window.freeGiftThreshold * 100;
    const giftProductId = window.freeGiftProductId;
    const updatedCart = await fetch(
      window.Shopify.routes.root + "cart.js"
    ).then((res) => res.json());
    const cartTotal = updatedCart.total_price;
    const giftInCart = updatedCart.items.some(
      (item) => item.id === giftProductId
    );

    if (cartTotal >= thresholdCents && !giftInCart) {
      await fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          items: [
            {
              id: giftProductId,
              quantity: 1,
            },
          ],
        }),
      });

      window.liquidAjaxCart.cartRequestUpdate();
    } else if (cartTotal < thresholdCents && giftInCart) {
      const giftItems = updatedCart.items.filter(
        (item) => item.id === giftProductId
      );

      for (const gift of giftItems) {
        await fetch(window.Shopify.routes.root + "cart/change.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: gift.key,
            quantity: 0,
          }),
        });
      }

      window.liquidAjaxCart.cartRequestUpdate();
    }
  } catch (err) {
    console.error("Error in auto-gift logic:", err);
  }
};

const handleAutoGiftDebounced = debounce(handleAutoGiftByThreshold);

const originalXhrOpen = XMLHttpRequest.prototype.open;
XMLHttpRequest.prototype.open = function (method, url, ...args) {
  const xhr = this;
  xhr.addEventListener("loadend", function () {
    if (xhr.readyState === 4 && xhr.status >= 200 && xhr.status < 300) {
      if (url.includes("cart")) {
        try {
          const cart = JSON.parse(xhr.responseText);
          handleAutoGiftDebounced(cart);
        } catch (e) {
          console.warn("Failed to parse cart from XHR");
        }
      }
    }
  });
  return originalXhrOpen.apply(this, [method, url, ...args]);
};

const originalFetch = window.fetch;
window.fetch = async function (...args) {
  const [url] = args;
  const response = await originalFetch(...args);

  if (url.includes("cart/")) {
    handleAutoGiftDebounced();
  }

  return response;
};
